module.exports = __webpack_public_path__ + "static/img/zsk.07320cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/zsk.png
// module id = qPkg
// module chunks = 0